import type { CodeSystem, CodeSystemConcept } from '@medplum/fhirtypes';

const URL = 'https://liza.health/fhir/CodeSystem/pgic';

/** System for the PGIC answer options (the 1–7 scale the patient picks from). The scored ordinal
 * (1–7) and Spanish display live on the Questionnaire answerOption, not here. PGIC has no LOINC
 * answer codes, so these are minted in-house. */
export const PGIC_SYSTEM = URL;

const CONCEPTS = [
  { code: 'very-much-improved', display: 'Very much improved' },
  { code: 'much-improved', display: 'Much improved' },
  { code: 'minimally-improved', display: 'Minimally improved' },
  { code: 'no-change', display: 'No change' },
  { code: 'minimally-worse', display: 'Minimally worse' },
  { code: 'much-worse', display: 'Much worse' },
  { code: 'very-much-worse', display: 'Very much worse' },
] as const satisfies CodeSystemConcept[];

export type PgicCode = (typeof CONCEPTS)[number]['code'];

export const pgicCodeSystem: CodeSystem = {
  resourceType: 'CodeSystem',
  url: URL,
  name: 'pgic',
  title: 'PGIC',
  identifier: [{ system: 'urn:ietf:rfc:3986', value: URL }],
  status: 'active',
  content: 'complete',
  concept: CONCEPTS,
};
